import React, { useState } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import RadioQuestion from "../../components/RadioQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";

export const NUMBER_OF_LIFETIME_ISAS_OPTIONS = [
  { title: "1", value: 1 },
  { title: "2", value: 2 },
  { title: "3", value: 3 },
  { title: "4", value: 4 },
];

const LifetimeIsa = ({ lifetimeIsa, onStepComplete }) => {
  const [formState, setFormState] = useState({
    numberOfSource: lifetimeIsa?.numberOfSource ?? null,
  });
  const [errors, setErrors] = useState({});
  const [errorMessages] = useState({
    numberOfSource: "Please fill this in",
  });

  const handleInputChange = (field) => (value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleValidation = () => {
    let newErrors = {};
    let formIsValid = true;

    if (formState.numberOfSource === null) {
      newErrors.numberOfSource = true;
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleRadioValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    setErrors((prev) => {
      let newErrors = { ...prev };

      if (!isBlur) {
        newErrors[field] = false;
      } else {
        if (formState[field] === null) {
          newErrors[field] = true;
        }
      }

      return newErrors;
    });
  };

  const saveLifetimeIsa = (event) => {
    event.preventDefault();

    if (handleValidation()) {
      onStepComplete({
        lifetimeIsa: {
          numberOfSource: formState.numberOfSource,
        },
      });
    }
  };

  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Tell us about your Lifetime ISAs" removeTopPadding>
        <p>You'll need to tell us a little about each Lifetime ISA you have</p>

        <RadioQuestion
          question="How many Lifetime ISAs will you be using to contribute towards your purchase?"
          options={NUMBER_OF_LIFETIME_ISAS_OPTIONS}
          inline={false}
          name="numberOfSource"
          selected={formState.numberOfSource}
          optionSelected={handleInputChange("numberOfSource")}
          validate={handleRadioValidation("numberOfSource")}
          validationError={errors.numberOfSource ? errorMessages.numberOfSource : null}
        />

        <Action onClick={saveLifetimeIsa}>Continue</Action>
      </Card>

      <Image src={imageCatAndHousePlant} />
    </React.Fragment>
  );
};

export default LifetimeIsa;
